import type { FlowMedia } from '@/types';
import { MAGIC_FLOW_WEBHOOK_URL } from '@/consts/urls';
import buildFlowMediaList from '@/utils/generation/buildFlowMediaList';

import pollUntilCompleted from './pollUntilCompleted';

/**
 * Every result of a finished flow run, in the order the backend returned them.
 *
 * The multi-output sibling of `getMediaFromFlowId`, which keeps only
 * `result[0]`. Throws (via `buildFlowMediaList`) when the run carries no usable
 * result.
 */
const getMediaListFromFlowId = async (id: string): Promise<FlowMedia[]> => {
  const pollingResponse = await pollUntilCompleted({
    url: `${MAGIC_FLOW_WEBHOOK_URL}/${id}/result`,
  });

  return buildFlowMediaList({ generationId: id, pollingResponse }).map(
    ({ resultFile }) => resultFile
  );
};

export default getMediaListFromFlowId;
